module.exports = __webpack_public_path__ + "static/aquadex-e72fc327e9008093243829a07e49ce97.jpg";